/** Device Capabilities */
export enum DeviceCapability {
  UNKNOWN = "UNKNOWN",
  TRANSMITTER = "TRANSMITTER",
  RECEIVER = "RECEIVER",
}

export enum DeviceClass {
  UNKNOWN = "UNKNOWN",
  ACCESSORY = "ACCESSORY",
  ACOUSTIC_RELEASE = "ACOUSTIC_RELEASE",
  BETA = "BETA",
  COMPONENT = "COMPONENT",
  DATALOGGER = "DATALOGGER",
  HUB = "HUB",
  RECEIVER = "RECEIVER",
  SENSOR = "SENSOR",
  TAG = "TAG",
}
